import Icon from '../components/Icon.vue'

Icon.register({
  umbrella: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32C320 14.3 305.7 0 288 0S256 14.3 256 32V49.9C138.3 62.6 29.5 144.5 0.3 280.8-1.9 290.9 8.8 302.1 19 292.2 71 237.2 126.7 239.8 177.6 329.2 182.9 338.7 192.5 337.8 197.3 329.2 217.5 293.8 242.2 256 288 256 346.5 256 376.2 324.8 378.7 329.2 383.5 337.8 393.1 338.7 398.4 329.2 449.4 239.7 505.5 237.8 557 292.2 567.3 302.2 577.9 290.9 575.7 280.8zM256 301.7V432C256 440.8 248.8 448 240 448 232.2 448 226.8 442.7 224.9 437.3 219 420.6 200.8 411.9 184.1 417.8 167.4 423.7 158.7 442 164.6 458.6 175.8 490.5 206.2 511.9 240 511.9 284.1 511.9 320 476 320 431.9V301.6C310.9 293.7 300.2 288 288 288 275.7 288.1 265.6 292.8 256 301.7z'
      }
    ]
  }
})
